<div [id]="dialogId" class="dialog-container">
  @if (data.title) {
    <h2 mat-dialog-title id="div-title">{{ data.title }}</h2>
  }
  <mat-dialog-content>
    <ng-template dlgHost #templateref></ng-template>
    @if (data.template) {
      <ng-container [ngTemplateOutlet]="data.template"></ng-container>
    }
    @if (data.message) {
      <h3 id="div-message">{{ data.message }}</h3>
    }
  </mat-dialog-content>
  <mat-dialog-actions id="div-actions">
    @if (showCancelbutton) {
      <button
        mat-button
        [mat-dialog-close]="result.cancel"
        class="btn btn-secondary me-5 ms-2"
        id="btn-cancel"
        >
        {{ cancelButtonText }}
      </button>
    }
    <div>
      @if (showNoButton) {
        <button
          mat-button
          [mat-dialog-close]="result.no"
          class="btn btn-secondary me-2"
          id="btn-no"
          >
          {{ noButtonText }}
        </button>
      }
      @if (showYesButton) {
        <button
          mat-button
          [mat-dialog-close]="result.yes"
          class="btn btn-primary"
          id="btn-yes"
          [disabled]="!isValid()"
          >
          {{ yesButtonText }}
        </button>
      }
    </div>
  </mat-dialog-actions>
</div>
